export const validateDocumentForm = (formData) => {
  const errors = {};

  if (!formData.documentType) {
    errors.documentType = "Document type is required";
  }

  if (!formData.name || formData.name.trim() === "") {
    errors.name = "Document name is required";
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors,
  };
};

export const validateFileType = (file, allowedTypes = []) => {
  if (allowedTypes.length === 0) return true;
  return allowedTypes.includes(file.type);
};

export const validateFileSize = (file, maxSizeBytes = 10 * 1024 * 1024) => {
  return file.size <= maxSizeBytes;
};
